<template>
	<div>
		<div class="border-gray bg-w p-3 flex justify-content-between">
			<div class="ftr-1-25 ftw600">
				<!-- 我的錢包（學生） -->
				{{$t('userMyWallet.myWallet')}}
			</div>
			<button type="button" class="btn btn-theme px-3" @click="visible = true" >{{$t('userMyWallet.recharge')}}</button>
		</div>
		<div class="border-gray bg-w p-3 px-4" style="border-top: none !important;">
			<div class="cl-info flex alcenter">
				<span class="mr40">
					{{$t('userMyWallet.availableBalance')}}
				</span>
				<a-tooltip placement="rightTop">
					<template #title>
						<div class="ft14 ftw600">{{$t('userMyWallet.availableBalance')}}</div>
					</template>
					<img src="../../../assets/image/staduents/1.png" width="20px" height="20px" />
				</a-tooltip>
			</div>
			<div class="flex alcenter mt-2">
				<img src="../../../assets/image/staduents/myWallet-coin.png" alt="" style="width: 80px;" />
				<div class="ms-3">
					<div class="ft20 cl-black">
						Mira Coins:{{convertCurrency(userInfo.money)}} 
						<a-tooltip placement="rightTop">
							<template #title>
								<div class="ft14 ftw600"> 1 Mira Coin ≈ HK$1 </div>
							</template>
							<img src="../../../assets/image/staduents/1.png" width="20px" height="20px" />
						</a-tooltip>
					</div>
					<div class="cl-black ftw600 ft24">
						≈ {{getCurrency()}} {{convertCurrency(userInfo.money)}} 
					</div>
					<div class="mt-2">
						*USD {{ (Number(userInfo.money) * Number(rate)).toFixed(2) }}
					</div>
				</div>
			</div>
			<div class="cl-info mt-4">
				<!-- *此处所列金额为近似值，可能因汇率变动而有轻微差别，所有金额均以美元为单位 -->
				{{$t('userMyWallet.approximateAmountTip')}}
			</div>
			
		</div>
		
		<div class="border-gray bg-w p-3 mt-4 flex justify-content-between" style="padding-bottom: 0 !important;">
			<div class="ftr-1 ftw600 cl-theme" style="border-bottom: 3px solid #52C4C9;padding-bottom: 0.5rem;">
				<!-- 钱包交易详情 -->
				{{$t('userMyWallet.walletTransactionDetails')}}
			</div>
		</div>
		<div class="border-gray bg-w p-3 px-4" style="border-top: none !important;">
			<div class="flex border-b py-3">
				<div class="" style="width: 20%;">
					{{$t('userMyWallet.time')}}
				</div>
				<div class="text-center" style="width: 18.75%;">
					{{$t('userMyWallet.item')}}
				</div>
				<div class="text-center" style="width: 18.75%;">
					{{$t('userMyWallet.teacherName')}}
				</div>
				<div class="text-center" style="width: 18.75%;">
					{{$t('userMyWallet.classNumber')}}
				</div>
				<div class="text-center" style="width: 18.75%;">
					{{$t('userMyWallet.orderId')}}
				</div>
				<div class="text-center" style="width: 18.75%;">
					{{$t('userMyWallet.amount')}}（{{getCurrency()}}）
				</div>
				
				
			</div>
			<div class="flex py-3" v-for="(item,index) in list">
				<div class="" style="width: 20%;">
					{{convertToTimeZone(item.createtime).formattedTime}}
					
				</div>
				<div class="text-center over-hide" style="width: 18.75%;">
					<span v-if="item.source==1">後臺增加</span>
					<span v-if="item.source==2">後臺減少</span>
					<span v-if="item.source==3">課程結算</span>
					<span v-if="item.source==4">體現扣除</span>
					<span v-if="item.source==5">體現駁回</span>
					<span v-if="item.source==2">取消體現</span>
					<span v-if="item.source==7">轉賬學生錢包</span>
				</div>
				<div class="text-center over-hide text-underline" style="width: 18.75%;">
					{{item.teacher_name}}
				</div>
				<div class="text-center cl-theme ftw600" style="width: 18.75%;">
					{{item.course_classify_name}} | {{item.is_experience=='1'?'25':'50'}}分鐘 x {{item.quantity}}堂
				</div>
				<div class="text-center" style="width: 18.75%;">
					{{item.memo}}
				</div>
				<div class="text-center" :class="item.ltype==1?'cl-theme':'cl-red'" style="width: 18.75%;">
					{{item.ltype==1?'+':'-'}}{{getCurrency()}} {{convertCurrency(item.money)}}
				</div>
			</div>
		</div>
		<div class="" v-if="visible">
			<recharge :visible="visible" @cancel="handleCancel()"></recharge>
		</div>
		
	</div>
</template>

<script>
	import recharge from '../../../components/recharge.vue'
	export default{
		components:{
			recharge
		},
		data(){
			return{
				visible:false,
				amountInfo:{
					amount:0,
					amountCommission:0,
					total:0
				},
				list:[],
				rate:1
			}
		},
		created(){
			this.moneyLogList()
			this.getrealRate()
		},
		methods:{
			getrealRate(){
				this.$http.api('common/realRate',{
					currency:'CNY'
				}).then(res=>{
					this.rate = Number(res.result.list['USD'].rate)
				})
			},
			handleCancel(){
				this.visible = false
			},
			moneyLogList(){
				this.$http.api('wallet/moneyLogList',{
					page:1,
					limit:1000
				}).then(res=>{
					this.list = res.list 
				})
			}
		}
	}
</script>

<style>
</style>